import { IAvailableModel } from '../libs/models/GenAIModels';

// Canonical list of models the DCA Copilot can route to — shared by every
// surface with a model picker (chat drawer, Agents tab, Evals tab) so there's
// one place to add/remove a model.
export const AVAILABLE_MODELS: IAvailableModel[] = [
  { id: 'gemini/gemini-3.1-pro-preview', label: 'Gemini Pro', provider: 'Google' },
  { id: 'claude-sonnet-5', label: 'Claude Sonnet 5', provider: 'Anthropic' },
  { id: 'claude-haiku-4-5', label: 'Claude Haiku 4.5', provider: 'Anthropic' },
  { id: 'gemma-4', label: 'Gemma 4', provider: 'Google' },
  // Scientific Lit. FAQ only (its AgentsSidebar entry explicitly allow-lists
  // this id) — a future fine-tuning pipeline will target this model
  // specifically, so it's scoped to the one agent that'll demo it rather
  // than exposed on every surface that reads this list (chat drawer, Evals
  // tab). "olmo-3-7b" is the bare LiteLLM proxy alias, confirmed directly
  // against the proxy — not a provider-prefixed string like "openai/...".
  { id: 'olmo-3-7b', label: 'OLMo 3', provider: 'AI2' },
];
